// Bump AVAILABILITY_CONSENT_VERSION to force re-consent on all drivers.
export const AVAILABILITY_CONSENT_VERSION = '1.0';

export const AVAILABILITY_CONSENT_TEXT =
  "I understand that my availability is voluntarily provided by me and is not a required " +
  "schedule. I agree that the system may use my availability, start location, and routing tools " +
  "to offer trip opportunities that fit my selected availability while preserving my independent " +
  "contractor status.";

// Bump SAFETY_NOTICE_VERSION to force re-acknowledgement on all drivers.
export const SAFETY_NOTICE_VERSION = '1.0';

export const SAFETY_NOTICE_TEXT =
  "Please obey all traffic laws and do not use this app while driving if unsafe or unlawful. " +
  "By logging in, you confirm that you and your vehicle meet all applicable legal, licensing, " +
  "insurance, company, and safety requirements, and that your vehicle is fit for service.\n\n" +
  "Press OK to confirm your understanding and acceptance of this notice.";
